import GeneratingOffers from "./GeneratingOffers";
export default GeneratingOffers;
